type ToolLinksProps = {
  locale?: "en" | "es";
  current?: "aesthetic" | "discord" | "roblox" | "tiktok";
};

export function ToolLinks({ locale = "en", current }: ToolLinksProps) {
  return <>
    <a href={locale === "es" ? "/es/" : "/"} aria-current={current === "aesthetic" ? "page" : undefined}>Aesthetic Bio Maker</a>
    <a href="/discord-bio/" hrefLang="en" aria-current={current === "discord" ? "page" : undefined}>Discord Bio Maker{locale === "es" && " (inglés)"}</a>
    <a href="/roblox-bio/" hrefLang="en" aria-current={current === "roblox" ? "page" : undefined}>Roblox Bio Maker{locale === "es" && " (inglés)"}</a>
    <a href="/tiktok-bio/" hrefLang="en" aria-current={current === "tiktok" ? "page" : undefined}>TikTok Bio Maker{locale === "es" && " (inglés)"}</a>
  </>;
}
